export const version = "2.998.43";
export const domain = "https://nqapp.nurulquran.com"
